import { useCallback } from 'react';
import { useHistory } from 'react-router';
import { DashboardConfig, PageConfig, PageHandle } from './types';
import { getCustomDashboardPageLink } from './utils';

export const usePageHandle = (
  dashboardConfig: DashboardConfig,
  pageNumber: number
): PageHandle => {
  const history = useHistory();
  const { pages } = dashboardConfig;
  const selected =
    pages
      .filter((p) => p.enabled)
      .find((p) => (pageNumber ? pageNumber === p.pageNumber : 1)) ?? pages[0];
  return {
    selected,
    pages,
    setter: useCallback(
      (page: PageConfig) => {
        const link =
          page.link ??
          getCustomDashboardPageLink(dashboardConfig.id, page.pageId);
        history.push(link);
      },
      [history, dashboardConfig.id]
    ),
  };
};
